import ResizeObserverPolyfill from 'resize-observer-polyfill'
if (typeof window !== 'undefined' && !window.ResizeObserver) {
  window.ResizeObserver = ResizeObserverPolyfill as typeof ResizeObserver
}
if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual'
}
import { isDev, isDevelopmentMode } from '@/utils/env'
import eruda from 'eruda'

// ========== VConsole 调试工具 ==========
// 测试环境或带 debug 参数时自动加载 vconsole
;(async function initDebug() {
  const isTest = isDev() || isDevelopmentMode()
  if (isTest) {
    eruda.init()
    console.log('[Eruda] 初始化成功', eruda)
  }
})()

import '@/assets/tailwind.css'
import '@/assets/reset.css'
import '@/assets/base.css'
// import '@/assets/theme.css'
import '@ideaflow/ui/theme.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import 'vant/es/toast/style'
import 'vue-sonner/style.css'
import App from './App.vue'
import router, { preloadRouteComponents } from './router'
// import 'amfe-flexible'
// 在项目最开始的地方引入下面的代码
import browserClient from '@apmplus/web' // 配置参数
import { ConfigPlugin } from '@ideaflow/ui/plugins/configPlugin'
import { getEnvMode } from '@/utils/env'
import { setupPermissionDirective } from '@/directives/permission'
import { useThemeStore } from '@/stores/theme'
import { startDreamaPerformanceMonitor } from '@/utils/performance/dev-monitor'
import { preloadStateImages } from '@/utils/state-images'
// ========== 隐藏原生标题栏 ==========
browserClient('init', {
  aid: 1001372,
  token: '78cce5480c2b423a91c1ab19f4af38f5',
})
browserClient('start')
const sendError = () => {
  window.onerror = function (msg, url, line, col, error) {
    console.log('onerror', msg, url, line, col, error)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ;(browserClient as any)('sendEvent', {
      name: 'js_error',
      metrics: { msg: msg, url: url, line: line, col: col, stack: (error && error.stack) || '' },
    })
  }
  window.onunhandledrejection = function (e) {
    const reason = e.reason || {}
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ;(browserClient as any)('sendEvent', {
      name: 'promise_error',
      metrics: { msg: reason.message || String(reason), stack: reason.stack || '' },
    })
  }
}
sendError()

async function bootstrap() {
  const app = createApp(App)

  app.use(ConfigPlugin, {
    env: getEnvMode(),
  })

  // Vue 全局错误处理器 - 捕获组件渲染和生命周期钩子中的错误
  app.config.errorHandler = (err, instance, info) => {
    console.log('Vue error', err, instance, info)
    const error = err as Error
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ;(browserClient as any)('sendEvent', {
      name: 'vue_error',
      metrics: {
        msg: error?.message || String(err),
        stack: error?.stack || '',
      },
    })
  }

  const pinia = createPinia()
  pinia.use(piniaPluginPersistedstate)
  app.use(pinia)

  setupPermissionDirective(app)
  useThemeStore()
  app.use(router)
  await router.isReady()
  app.mount('#app')
  window.requestAnimationFrame(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  })
  preloadRouteComponents()
  preloadStateImages()
  startDreamaPerformanceMonitor()
}

void bootstrap()
